<template>
        <div
            class="profession-heading-details"
            :class="{ _desktop: desktopAndMore, _tablet: tabletAndLess, _phone: phoneAndLess }"
        >
            <svg
                v-if="tabletAndLess"
                class="profession-heading-details-close"
                width="28"
                height="28"
                @click="$emit('close')"
            >
                <use xlink:href="#close"/>
            </svg>
            <ul>
                <li
                    v-for="item in getProfessions"
                    :key="`profession-${item.profileId}`"
                >
                    <router-link :to="item.publicationLink">
                        {{ item.name }}
                    </router-link>
                </li>
                <li
                    v-for="item in directSoftCompetences"
                    :key="`soft-${item.id}`"
                >
                    <router-link :to="{ name: 'competence', params: { id: item.id } }">
                        {{ item.name }}
                    </router-link>
                </li>
                <li
                    v-for="item in directHardCompetences"
                    :key="`hard-${item.id}`"
                >
                    <router-link :to="{ name: 'professional-skill', params: { id: item.id } }">
                        {{ item.name }}
                    </router-link>
                </li>
            </ul>
        </div>
</template>

<script>
import { mapGetters } from 'vuex';
const accountTrackGetters = [
    'getSoftCompetences',
    'getHardCompetences',
    'getProfessions',
    'getGoals',
];

export default {
    name: 'GoalsPopup',
    computed: {
        ...mapGetters('accountTrack', accountTrackGetters),
        ...mapGetters(['width']),
        directSoftCompetences() {
            return this.getSoftCompetences.filter(el => el.isDirect);
        },
        directHardCompetences() {
            return this.getHardCompetences.filter(el => el.isDirect);
        },
        desktopAndMore() {
            return this.width > 768;
        },
        tabletAndLess() {
            return this.width <= 768;
        },
        phoneAndLess() {
            return this.width <= 376;
        },
        showChartDialog() {
            if (this.tabletAndLess) {
                return this.chartDialog;
            }
            return true;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.profession-heading-details {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 100%;
    &._tablet {
        left: 32px;
        right: 32px;
        top: 96px;
    }
    &._phone {
        left: 16px;
        right: 16px;
    }
    ul {
        padding: 24px;
        margin: 8px 0 0;
        background-color: #FFFFFF;
        box-shadow: 0 2px 16px rgba(155, 161, 166, 0.4);
        border-radius: 4px;
        text-align: left;
    }
    li {
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 26px;
        list-style: none;
        &:not(:last-child) {
            margin-bottom: 16px;
        }
    }
    li a {

    }
    li:hover,
    li a:hover {
        color: #4663AB;
    }
}

.profession-heading-details-close {
    cursor: pointer;
    position: absolute;
    top: 16px;
    right: 8px;
}

</style>
